import { CarrierRateChangeSetStatus } from "@redotech/crdb-enums/fulfillment/carrier-rate-change-set-status";
import * as z from "zod";
import { carrierRateChangeSetSchema } from "./carrier-rate-change-set";

export const decideCarrierRateChangeSet = {
  name: "decideCarrierRateChangeSet" as const,
  input: z.object({
    id: z.string(),
    decision: z.enum([
      CarrierRateChangeSetStatus.Approved,
      CarrierRateChangeSetStatus.Rejected,
    ]),
    note: z.string().optional(),
  }),
  output: z.object({ changeSet: carrierRateChangeSetSchema }),
};
